export default {
    copyObj: copyObj,
    resetObj: resetObj
}

function copyObj(origin,target){
    for(var i in origin){
        origin[i]=target[i]
    }
}

function resetObj(origin){
    for(var i in origin){
        origin[i] = ''
    }
}


// WEBPACK FOOTER //
// ./src/components/common/objOperate.js